'use strict'

/**
 * @typedef {Object} TBasSystemState
 * @property {boolean} hasSystem
 */

angular
  .module('basalteApp')
  .constant('SECURITY', {
    EVT_COUNTDOWN_UPDATED: 'evtCountdownUpdated',
    EVT_FORCE_CLOSE_COUNTDOWN_MODAL: 'evtForceCloseCountdownModal',
    EVT_SENSOR_STATE_CHANGED: 'evtSensorState',
    EVT_SYSTEM_STATE_CHANGED: 'basSystemStateChanged',
    BAS_SYSTEM_STATE_ARMING: 'arming',
    BAS_SYSTEM_STATE_ARMED: 'armed',
    BAS_SYSTEM_STATE_DISARMED: 'disarmed',
    BAS_SYSTEM_STATE_TRIGGERED: 'triggered',
    BAS_SYSTEM_STATE_UNKNOWN: 'unknown',
    BAS_ALARM_TYPE_VACATION: 'vacation',
    BAS_ALARM_TYPE_AWAY: 'away',
    BAS_ALARM_TYPE_HOME: 'home',
    BAS_ALARM_TYPE_NIGHT: 'night',
    BAS_ALARM_TYPE_DISARM: 'disarm',
    BAS_ALARM_TYPE_ARM: 'arm',
    BAS_ALARM_TYPE_CUSTOM: 'custom',
    BAS_ALARM_ICON_HOME: 'shieldStay',
    BAS_ALARM_ICON_AWAY: 'shieldCheck',
    BAS_ALARM_ICON_ARMED: 'shieldLock',
    BAS_ALARM_ICON_DISARMED: 'shield',
    BAS_ALARM_ICON_TRIGGERED: 'securityAlarm',
    ACTIVE_STATE_OPEN: 'open',
    ACTIVE_STATE_TRIGGERED: 'triggered',
    ACTIVE_STATE_ACTIVATED: 'activated',

    /**
     * @type {TBasSystemState}
     */
    SYSTEM_STATE: {
      hasSystem: false
    }
  })
